import { store } from "data/DataProvider";
import { modalActions } from "data/reducers/modal";

// 'fire-n-forget' convenience method for displaying a modal.
// This needs to live outside of data/reducers/modal so that we don't
// get circular dependencies.
export const showModal = (type, props) => store.dispatch(modalActions.showModal(type, props));

// same but for dimissing the current modal. for it you need
// to do that from elsewhere in code
export const dismissModal = (type, props) => store.dispatch(modalActions.dismissModal());

// this one's for if you need to send updated props to the current
// modal. you can send just the props you want to update, other props
// will be persisted from the previous set of props
export const updateModalProps = (nextProps) => store.dispatch(modalActions.updateModalProps(nextProps));
